module.exports = __webpack_public_path__ + "static/media/text-reader_99.b775fb12.webp";